import { ActuatorTypes } from 'src/actuators/user-input/calculations/constants.ts';
import { Filter } from 'src/utils/composeFilter.ts';
import { NavigateFunction } from 'react-router/dist/lib/hooks';
import { PATHS } from 'src/actuators/common/types/Paths';

export const detectActuatorType = (filter: Filter, navigate?: NavigateFunction): ActuatorTypes => {
    if (filter.Family?.includes('Linear')) {
        return ActuatorTypes.Linear;
    } if (filter.Family?.includes('Non fail-safe')) {
        return ActuatorTypes.NonFailSafe;
    } if (filter.Family?.includes('Fail-safe')) {
        return ActuatorTypes.FailSafe;
    } if (filter.Family?.includes('Harsh environmental conditions')) {
        return ActuatorTypes.HarshEnvironment;
    } if (filter.Family?.includes('Fast running') || filter.Family?.includes('Quick running')) {
        return ActuatorTypes.Fast;
    } if (navigate) {
        navigate({
            pathname: PATHS.Home,
        });

        return ActuatorTypes.FailSafe;
    }

    return ActuatorTypes.FailSafe;
};
